import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { emailRegex, phoneRegex, fullPhoneRegex, otpRegex, phoneOrMailRegex } from './variables';

export class cValidators {
    static required: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        return ((typeof control.value == 'string' && control.value.trim() == '') || control.value == undefined || control.value == null) ? { 'required': true } : null;
    }

    static positiveNumber: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const regexp = new RegExp('/[0-9]+/');
        return regexp.test(control.value) ? null : { 'credits': true };
    }

    static trimValue(value: any) {
        return value.trim();
    }

    static cif: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const value = control.value.toUpperCase();

        if (!value) {
            return { 'required': true };
        }

        let cif = value.replace(/\s/g, '');
        cif = cif.replace('-', '');

        const cifRegex = /^[A-HJNPQRSUVW]{1}\d{7}[0-9A-J]$/;

        if (!cifRegex.test(cif)) {
            return { 'cif': true };
        }

        const firstLetter = cif[0];
        const digits = cif.slice(1, 8);
        const lastLetter = cif[8];

        const controlLetters = 'JABCDEFGHI';
        const controlDigit = controlLetters.charAt(digits % 23);

        if (firstLetter === 'P' || firstLetter === 'Q' || firstLetter === 'S' || firstLetter === 'W') {
            return lastLetter === controlDigit ? { 'cif': true } : null;
        } else if (firstLetter === 'K' || firstLetter === 'L' || firstLetter === 'M') {
            return /^[A-Z]$/.test(lastLetter) ? { 'cif': true } : null;
        }

        return null;
    }

    static nif: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const value = control.value.toUpperCase();

        if (!value) {
            return { 'required': true };
        }

        let nif = value.replace(/\s/g, '');

        const regex = /^(?:[XYZ0-9][0-9]{7,8}[-]?[TRWAGMYFPDXBNJZSQVHLCKE]|[0-9]{8}[-]?[TRWAGMYFPDXBNJZSQVHLCKE][XYZ])$/;

        if (!regex.test(nif)) {
            return { 'nif': true };
        }

        nif = nif.replace('-', '');

        const validLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        const letter = nif.slice(-1).toUpperCase();
        const number = nif.slice(0, -1);

        let expectedLetter = '';

        if (nif[0] === 'X' || nif[0] === 'Y' || nif[0] === 'Z') {
            const numberNIE = nif.slice(1, -1);
            const firstLetter = nif[0];
            let prefixedNumber = numberNIE;

            if (firstLetter === 'X') {
                prefixedNumber = '0' + numberNIE;
            } else if (firstLetter === 'Y') {
                prefixedNumber = '1' + numberNIE;
            } else if (firstLetter === 'Z') {
                prefixedNumber = '2' + numberNIE;
            }

            const index = parseInt(prefixedNumber, 10) % 23;
            expectedLetter = validLetters[index].toUpperCase();
        } else {
            const index = parseInt(number, 10) % 23;
            expectedLetter = validLetters[index];
        }

        if (letter === expectedLetter) {
            return null;
        }

        return { 'nif': true };
    }

    static nifcif: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const n = new FormControl(control.value, cValidators.nif);
        const c = new FormControl(control.value, cValidators.cif);

        let cn = null;

        if (c.errors !== null && n.errors !== null) {
            if (n.errors !== null) {
                cn = n.errors;
            }

            if (c.errors !== null) {
                cn = c.errors;
            }

        }

        return cn;
    }

    static nifNie: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const nifValidator = new FormControl(control.value, cValidators.nif);

        if (nifValidator.errors === null) {
            return null;
        }

        const value = control.value ? control.value.toUpperCase() : '';

        if (!value) {
            return { 'required': true };
        }

        let nie = value.replace(/\s/g, '');
        nie = nie.replace('-', '');

        const nieRegex = /^[XYZ][0-9]{7,8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;

        if (!nieRegex.test(nie)) {
            return nifValidator.errors;
        }

        const validLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        const letter = nie.slice(-1).toUpperCase();

        let number = nie.slice(1, -1);
        const firstLetter = nie[0];

        if (firstLetter === 'X') {
            number = '0' + number;
        } else if (firstLetter === 'Y') {
            number = '1' + number;
        } else if (firstLetter === 'Z') {
            number = '2' + number;
        }

        const index = parseInt(number, 10) % 23;
        const expectedLetter = validLetters[index];

        if (letter === expectedLetter) {
            return null;
        }

        return { 'nifnie': true };
    }

    static email: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const regexp = new RegExp(emailRegex);
        return regexp.test(control.value) ? null : { 'email': true };
    }

    static repeat: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        if (control.parent) {
            const values = control.parent.controls;
            for (const key in values) {
                if (values[key] == control) {
                    if (key.indexOf('Repeat') > -1) {
                        const key2 = key.replace('Repeat', '');
                        return control.value == values[key2].value ? null : { 'repeat': true };
                    } else {
                        const key2 = key + 'Repeat';
                        values[key2].updateValueAndValidity({ onlySelf: true, emitEvent: false });
                        return null;
                    }
                }
            }
        }
    }

    static hasLength(n: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const length = control.value ? control.value.length : 0;
            return length === n ? null : { hasLength: true };
        };
    }

    static phone: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const regexp = new RegExp(phoneRegex);

        if (control.value) {
            return regexp.test(control.value) ? null : { 'phone': true };
        }

        return null;
    }

    static fullPhone: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const regexp = new RegExp(fullPhoneRegex);

        return regexp.test(control.value) ? null : { 'phone': true };
    }

    static OTP: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const regexp = new RegExp(otpRegex);

        return regexp.test(control.value) ? null : { 'otp': true };
    }

    static phoneOrMail: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const regexp = new RegExp(phoneOrMailRegex);

        return regexp.test(control.value) ? null : { 'tlfmail': true };
    }

    static max(n: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const length = control.value ? ((typeof control.value === 'string') ? control.value.length : control.value) : 0;

            return length <= n ? null : { max: true };
        };
    }

    static min(n: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const length = control.value ? ((typeof control.value === 'string') ? control.value.length : control.value) : 0;

            return length >= n ? null : { min: true };
        };
    }
}
